export const STAGE_URL = 'https://stagepurchase.fcappservices.in/buyou/index.php/'
export const LIVE_URL = 'https://in-buyou.brainbees.com/buyou/index.php/'
// export const LIVE_URL = STAGE_URL
export const PRODUCT_IMG_URL = 'https://cdn.fcglcdn.com/brainbees/images/products/'
export const SUBCAT_IMAGE_URL = 'https://cdn.fcglcdn.com/brainbees/thehandbook/subcategories/'

export const IMAGE_URL_LIVE = 'https://cdn.fcglcdn.com/brainbees/jsons/fcimagenames/'

export const MULTIPLE_IMAGE_URL = 'https://cdn.fcglcdn.com/brainbees/jsons/fcimagenames/'

